<div>
    <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-md-4">
            <label for="templateName">Name *</label>
            <input
                id="templateName"
                type="text"
                pInputText
                [(ngModel)]="template.name"
            />
        </div>
        <div class="p-field p-col-12 p-md-4">
            <label for="templateLocation">Template Context *</label>
            <p-dropdown
                id="templateLocation"
                [options]="templateLocations"
                [(ngModel)]="template.location"
                placeholder="Select a location"
                (onChange)="onTemplateLocationChange($event)"
                optionLabel="label"
                optionValue="value"
            ></p-dropdown>
        </div>
        <div
            class="p-field p-col-12 p-md-12"
            *ngIf="templatesWithSubjectContents.has(template.location)"
        >
            <label for="subjectContents">Subject</label>
            <br>
            <quill-editor
                #subjectEditor
                class="quill-editor"
                id="subjectContents"
                [(ngModel)]="template.subjectContents"
                format="object"
                [modules]="{toolbar: [], variableToolbar: true}"
                (onEditorCreated)="onEditorCreated()"
                placeholder="Write subject for email"
            ></quill-editor>
        </div>
        <div class="p-field p-col-12 p-md-12">
            <label for="templateContents">Contents *</label>
            <br>
            <quill-editor
                #editor
                class="quill-editor fill-height"
                id="templateContents"
                [(ngModel)]="template.contents"
                format="object"
                [modules]="modules"
                (onEditorCreated)="onEditorCreated()"
                placeholder="Write contents of the template here"
            ></quill-editor>
        </div>
    </div>
    <div class="p-d-flex p-jc-end">
        <button
            pButton
            type="button"
            label="Cancel"
            icon="pi pi-times"
            class="p-button-text"
            (click)="cancel()"
        ></button>
        <button
            pButton
            type="button"
            [label]="isEditMode ? 'Edit Template': 'Create Template'"
            icon="pi pi-check"
            class="p-button-primary"
            (click)="save()"
        ></button>
    </div>
</div>